import { Component, OnInit, Injectable, Inject, PLATFORM_ID  } from '@angular/core';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'download',
    templateUrl: './download.component.html'
})
export class DownloadComponent implements OnInit {

  env = environment;

  constructor() { }

  ngOnInit() {
  }

}
